import { Row, FilterFn } from '@tanstack/react-table';
import { rankItem } from '@tanstack/match-sorter-utils';

// export function multiSelectFilter<T extends object>(rows: Row<T>[], columnId: keyof T, filterValue: string[]) {
//     return filterValue.length === 0
//         ? rows
//         : rows.filter((row) => {
//               if (filterValue) console.log(1111, row.original);
//               return filterValue.includes(String(row.original[columnId]));
//           });
// }
export const multiSelectFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    return true;
    // return Array.isArray(value) && value.length > 0 ? value.includes(String(row.original[columnId])) : true;
};

export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value);

    // Store the itemRank info
    addMeta({
        itemRank
    });

    // Return if the item should be filtered in/out
    return itemRank.passed;
};
